export const META_FLOWS_DOCS_URL = 'https://developers.facebook.com/docs/whatsapp/flows';
export const META_BUSINESS_URL = 'https://business.facebook.com/';

export const categoryLabels = {
  ventas: 'Ventas',
  ecommerce: 'E-commerce',
  servicios: 'Servicios',
  soporte: 'Soporte',
  b2b: 'B2B'
};

export const getWhatsappFlowTemplateRoute = (category, templates, onSelect) => ({
  routeProps: {
    key: category,
    title: categoryLabels[category] || category
  },
  subRoutes: templates.map((template) => ({
    routeProps: {
      key: template.web_id,
      title: template.name,
      onClick: () => onSelect(template)
    }
  }))
});
